// extracted by mini-css-extract-plugin
export default {"form":"vDsoV","submitButton":"tjMLC","skeleton-progress":"uHGaH"};